import { Box } from '@common-fe/common-fe';
import styled from 'styled-components';

interface WrapperProps {
  isSmallViewVersion?: boolean;
  isFlex?: boolean;
}

export const Wrapper = styled(Box)<WrapperProps>`
  ${({ isSmallViewVersion }) =>
    isSmallViewVersion
      ? `display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-column-gap: 12px;
    grid-row-gap: 12px;`
      : `>div:not(:last-child) {
      
    }`}
  ${({ isFlex }) => (isFlex ? 'display: flex' : undefined)}
`;

export const ImgSquare = styled.img`
  display: block;
  object-fit: contain;
  width: 100%;
  height: 100%;
`;

export const ImgThumbOuter = styled.div<{
  active: boolean;
  isScanUpload?: boolean;
}>`
  background-color: ${({ theme }) => theme.colors.canvas};
  box-sizing: border-box;
  width: ${({ theme }) => theme.spacings.spacing72};
  height: ${({ theme }) => theme.spacings.spacing72};
  padding: ${({ theme }) => theme.spacings.spacing4};
  border-radius: ${({ theme }) => theme.rounds.fieldRound};
  overflow: hidden;
  cursor: pointer;
  isolation: isolate;
  border: ${({ active, isScanUpload, theme }) => {
    if (isScanUpload) return `2px solid transparent`;
    if (active) return `2px solid ${theme.colors.background3}`;
    return `2px solid transparent`;
  }};
  &:hover {
    border: ${({ active, isScanUpload, theme }) => {
      if (isScanUpload) return `2px solid ${theme.colors.accentActive}`;
      if (active) return `2px solid ${theme.colors.background3}`;
      return `2px solid ${theme.colors.border}`;
    }};
  }
`;

export const ImgThumbInner = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.canvas};
  width: 100%;
  height: 100%;
  border: 1px solid ${({ theme }) => theme.colors.border1};
  border-radius: ${({ theme }) => theme.rounds.dropdownItemRound};
  overflow: hidden;
`;

export const CloseButton = styled.div`
  position: absolute;
  z-index: 3;
  top: 2px;
  right: 2px;
  width: ${({ theme }) => theme.spacings.spacing20};
  height: ${({ theme }) => theme.spacings.spacing20};
  background-color: ${({ theme }) => theme.colors.danger};
  border-radius: ${({ theme }) => theme.rounds.button2Round};
  color: ${({ theme }) => theme.colors.textAccent};
  display: none;
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: ${({ theme }) => theme.colors.dangerHover};
  }
  ${ImgThumbOuter}:hover & {
    display: flex;
  }
`;

export const UploadContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 5px 10px;
  box-sizing: border-box;
`;

export const UploadText = styled.h4`
  ${({ theme }) => theme.fonts.text12Medium};
  color: ${({ theme }) => theme.colors.textDisabled};
  ${ImgThumbOuter}:hover & {
    color: ${({ theme }) => theme.colors.accentActive};
  }
  margin-top: ${({ theme }) => theme.spacings.spacing2};
  text-align: center;
  line-height: 14px;
`;
